module.exports = __webpack_public_path__ + "static/media/Not-cleared.206ab088.svg";